import { Dispatch, SetStateAction } from 'react'

import { useSiteOperatorListApi } from '@/common/api/modules/siteOperator'
import { SearchConditionBase } from '@/common/api/search'
import { articleApprovalStatusLabel } from '@/common/app/modules/media/articleApproval'
import { useSiteId } from '@/common/app/site'

import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'
import DisclosureSortRadioSelect from '@/components/view/molecules/disclosure/DisclosureSortRadioSelect'

// 承認リクエスト一覧の検索条件
export interface ArticleApprovalCondition extends SearchConditionBase {
  status: string | null
  requestedBy: number | null
  approverId: number | null
}

export const DEFAULT_ARTICLE_APPROVAL_CONDITION: ArticleApprovalCondition = {
  page: 1,
  perPage: 50,
  status: null,
  requestedBy: null,
  approverId: null
}

const STATUS_VALUES = ['pending', 'upload_ready', 'rejected']

interface Props {
  condition: ArticleApprovalCondition
  setCondition: Dispatch<SetStateAction<ArticleApprovalCondition>>
}

const ArticleApprovalSearchConditionField = ({ condition, setCondition }: Props) => {
  const siteId = useSiteId()
  const { data: operators } = useSiteOperatorListApi({ site_id: siteId })
  const operatorChoices = (operators ?? []).map((o) => ({ name: o.name, value: o.id }))

  return (
    <SearchConditionAreaContent>
      <SortButtonList>
        <DisclosureSortRadioSelect
          name='status'
          currentValue={condition.status}
          choices={STATUS_VALUES.map((status) => ({
            name: articleApprovalStatusLabel(status),
            value: status
          }))}
          setCondition={setCondition}
        >
          ステータス
        </DisclosureSortRadioSelect>
        <DisclosureSortRadioSelect
          name='requestedBy'
          currentValue={condition.requestedBy}
          choices={operatorChoices}
          setCondition={setCondition}
        >
          依頼者
        </DisclosureSortRadioSelect>
        <DisclosureSortRadioSelect
          name='approverId'
          currentValue={condition.approverId}
          choices={operatorChoices}
          setCondition={setCondition}
        >
          承認者
        </DisclosureSortRadioSelect>
      </SortButtonList>
    </SearchConditionAreaContent>
  )
}

export default ArticleApprovalSearchConditionField
